var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWinCoupons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 63.5,
    rx: 40,
    ry: 14.5,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 72.9812L12.5672 57.414V33.6149L12 33.2893V25.3481L39.5 41.227V72.9812Z",
    fill: "url(#paint0_linear_803_9623)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M39.5 72.9812L12.5672 57.414V33.6149L12 33.2893V25.3481L39.5 41.227V72.9812Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M39.4997 49.1649L29.8568 43.5977L29.8533 35.646L29.1915 35.2749L29.188 43.2126L12.5669 33.6152V34.7567L29.188 44.3505L29.1845 67.0256L29.8603 67.4142L29.8568 44.7357L39.4997 50.3029V49.1649Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 72.9812L66.2857 57.526V33.699L67 33.2893V25.3481L39.5 41.227V72.9812Z",
    fill: "url(#paint1_linear_803_9623)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M66.2857 33.6992L49.8116 43.2125L49.8081 35.2748L49.1464 35.646V43.5977L39.5 49.1649V50.3029L49.1429 44.7391L49.1394 67.4142L49.8151 67.0255L49.8116 44.3575L66.2857 34.8547V33.6992Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67 25.3482L39.5 9.4729L12 25.3482L39.5 41.2271L67 25.3482Z",
    fill: "url(#paint2_linear_803_9623)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M67 25.3482L39.5 9.4729L12 25.3482L39.5 41.2271L67 25.3482Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M34.8708 25.6635L21.7266 19.7461L22.3113 19.396L35.5676 25.3519",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M44.1261 25.6635L57.2703 19.7461L56.6821 19.396L43.4258 25.3519",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M49.8078 35.2747L40.0494 28.0304V28.0269L39.4997 27.6172L39.4962 27.6207V27.6172L38.943 28.0269L38.9465 28.0304L29.1846 35.2747L29.8498 35.6459L39.4962 28.44L49.146 35.6459L49.8078 35.2747Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6879 31.3042V63.8462L49.8146 67.8168L49.8076 35.2748L56.6879 31.3042Z",
    fill: "#F7E21E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8149 67.817L49.1392 67.4143L49.8149 67.0256V67.817Z",
    fill: "#C2AF03"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3115 31.3042V63.8462L29.1848 67.8168L29.1918 35.2748L22.3115 31.3042Z",
    fill: "#C2AF03"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1846 67.817L29.8603 67.4143L29.1846 67.0256V67.817Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1918 35.275L39.5034 27.6209L43.4355 25.3485L56.6883 19.3961L49.815 15.4255L39.5034 23.0796L35.5748 25.352L22.3115 31.3044L29.1918 35.275Z",
    fill: "#DECB1B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5753 25.3518L34.875 25.6634L37.1894 26.6893L38.9506 28.0269L39.5039 27.6172L37.7847 26.3427L35.5753 25.3518Z",
    fill: "#C2AF03"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.808 35.275L37.7842 26.3429L22.3115 19.3961L29.1883 15.4255L41.2226 24.3576L56.6883 31.3044L49.808 35.275Z",
    fill: "#DECB1B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3432 24.0459C37.3432 24.0459 29.2655 30.7511 16.0757 29.2245C16.0757 29.2245 21.6779 32.8904 28.5267 32.0606C28.5267 32.0606 27.5428 34.5606 21.7725 37.6033C21.7725 37.6033 36.1877 37.7364 39.9132 25.7686L37.3432 24.0459Z",
    fill: "#FAEE78"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7485 36.0695C33.7401 34.5709 38.0959 31.6157 39.9026 25.7788L37.3326 24.0562C35.7709 25.24 34.0634 26.2179 32.252 26.9658C32.252 26.9658 35.0532 28.1913 37.9103 27.435C37.2627 29.3828 36.1965 31.1652 34.7864 32.6568C33.3764 34.1485 31.6568 35.3134 29.7485 36.0695Z",
    fill: "#C2AF03"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4332 15.2748C19.4332 15.2748 21.0369 13.3981 25.9563 14.2454C28.9255 14.7601 33.9676 18.2195 36.4605 23.9828C36.7757 24.7111 37.483 24.9562 37.8611 25.4464C37.9489 25.5562 38.0449 25.6592 38.1482 25.7545L39.7063 25.772C39.7063 20.3869 36.6846 14.9527 33.8275 11.8084C30.9704 8.66419 26.2645 7.12707 22.9101 7.00803C21.7206 6.95306 20.535 7.18105 19.4507 7.67329C18.5369 10.2188 18.1587 12.7433 19.4332 15.2748Z",
    fill: "#FAEE78"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1172 23.2579C36.1172 23.2579 38.9183 22.3125 37.7663 17.8237C38.975 20.3043 39.6332 23.0168 39.6956 25.7754L38.1375 25.7579C38.0342 25.6625 37.9382 25.5595 37.8504 25.4498C37.4722 24.9596 36.7649 24.7145 36.4498 23.9862C36.3483 23.7341 36.2327 23.496 36.1172 23.2579Z",
    fill: "#C2AF03"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3046 18.7235C21.1244 17.7783 20.1478 16.6039 19.4335 15.2711C18.1555 12.7396 18.5336 10.2151 19.4335 7.6626C16.5483 8.93711 14.8256 12.6871 14.1814 15.7158C13.8312 17.4105 13.7892 18.8671 14.0763 19.5674C14.8852 21.4721 19.6226 29.1682 39.9132 25.7788L39.8922 23.6465C34.8116 23.3314 25.9391 21.7837 22.3046 18.7235Z",
    fill: "#FAEE78"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4332 15.2748C19.4332 15.2748 19.1916 9.34346 22.9101 7.00803C21.7206 6.95306 20.535 7.18105 19.4507 7.67329C18.5369 10.2188 18.1587 12.7433 19.4332 15.2748Z",
    fill: "#C2AF03"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6565 24.0459C41.6565 24.0459 49.7342 30.7511 62.924 29.2245C62.924 29.2245 57.3217 32.8904 50.473 32.0606C50.473 32.0606 51.4569 34.5606 57.2272 37.6033C57.2272 37.6033 42.8119 37.7364 39.0864 25.7686L41.6565 24.0459Z",
    fill: "#FAEE78"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0898 27.4283C43.9329 28.1846 46.7481 26.9591 46.7481 26.9591L46.2194 26.721L46.1388 26.686L45.6696 26.4654L45.5646 26.4164L45.1374 26.2028C45.1013 26.1863 45.0662 26.1676 45.0324 26.1468C44.8958 26.0803 44.7663 26.0103 44.6367 25.9437L44.5317 25.8877L44.1815 25.6881L44.08 25.6321L43.7509 25.443L43.6598 25.3905L43.3517 25.2154L43.2677 25.1664L43.0016 24.9984L42.9245 24.9493L42.6899 24.7953L42.6199 24.7498L42.4168 24.6132L42.3573 24.5712L42.1857 24.4521L42.1332 24.4136L41.9967 24.3156L41.9511 24.2806L41.8496 24.2035L41.8041 24.1685L41.7411 24.123L41.699 24.0915L41.678 24.0705L41.6535 24.053L40.8132 24.6167L39.0835 25.7757C42.8055 37.7435 57.2207 37.6104 57.2242 37.6104C49.8083 37.2603 42.0177 31.6335 41.0898 27.4283Z",
    fill: "#C2AF03"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5666 15.2748C59.5666 15.2748 57.9629 13.3981 53.0435 14.2454C50.0743 14.7601 45.0322 18.2195 42.5393 23.9828C42.2241 24.7111 41.5168 24.9562 41.1387 25.4464C41.0509 25.5562 40.9549 25.6592 40.8516 25.7545L39.2935 25.772C39.2935 20.3869 42.3152 14.9527 45.1723 11.8084C48.0295 8.66419 52.7353 7.12707 56.0897 7.00803C57.2792 6.95306 58.4648 7.18105 59.5491 7.67329C60.4629 10.2188 60.8586 12.7433 59.5666 15.2748Z",
    fill: "#FAEE78"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8821 23.2579C42.8821 23.2579 40.081 22.3125 41.233 17.8237C40.0243 20.3043 39.3662 23.0168 39.3037 25.7754L40.8618 25.7579C40.9651 25.6625 41.0611 25.5595 41.149 25.4498C41.5271 24.9596 42.2344 24.7145 42.5495 23.9862C42.651 23.7341 42.7666 23.496 42.8821 23.2579Z",
    fill: "#C2AF03"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M56.695 18.7235C57.8752 17.7783 58.8518 16.6039 59.5661 15.2711C60.8441 12.7396 60.466 10.2151 59.5661 7.6626C62.4513 8.93711 64.174 12.6871 64.8182 15.7158C65.1683 17.4105 65.2104 18.8671 64.9232 19.5674C64.1144 21.4721 59.377 29.1682 39.0864 25.7788L39.1074 23.6465C44.188 23.3314 53.0605 21.7837 56.695 18.7235Z",
    fill: "#FAEE78"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5667 15.2748C59.5667 15.2748 59.8083 9.34346 56.0898 7.00803C57.2794 6.95306 58.4649 7.18105 59.5492 7.67329C60.4631 10.2188 60.8587 12.7433 59.5667 15.2748Z",
    fill: "#C2AF03"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3013 24.3643C42.2791 24.1583 42.2026 23.9619 42.0796 23.7952C41.9565 23.6284 41.7914 23.4974 41.6011 23.4155C40.9272 23.1789 40.2134 23.0766 39.5002 23.1143C38.7668 23.0766 38.0338 23.1959 37.3504 23.4645C37.1752 23.5487 37.0248 23.6768 36.9138 23.8363C36.8027 23.9958 36.7348 24.1813 36.7166 24.3748C36.6431 25.0121 36.5976 26.0905 37.0177 26.7033C37.7099 27.2962 38.596 27.614 39.5072 27.5961C40.4146 27.6158 41.2968 27.2976 41.9827 26.7033C42.3994 26.08 42.3574 25.0016 42.3013 24.3643Z",
    fill: "#F7E21E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_803_9623",
    x1: 25.75,
    y1: 25.3481,
    x2: 25.75,
    y2: 72.9812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_803_9623",
    x1: 53.25,
    y1: 25.3481,
    x2: 53.25,
    y2: 72.9812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_803_9623",
    x1: 39.5,
    y1: 9.4729,
    x2: 39.5,
    y2: 41.2271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinCoupons);
export default __webpack_public_path__ + "static/media/winCoupons.d49ea790994a95b35b9517c1e914dd97.svg";
export { ForwardRef as ReactComponent };